<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 标题-->

    
    <!-- 提示1 -->
    <el-alert
      class="my-alert-1"
      :title="mydata.stepInfo.status_text"
      type="warning"
      show-icon
      v-if="Object.keys(mydata.stepInfo).length"
    />
    <!-- 提示2 -->
    <!-- <el-alert
      class="my-alert-2"
      title="审核驳回原因：1、图片不清晰 2、文件过期了"
      type="warning"
      show-icon
    /> -->
    <!-- 步骤条 -->
    <!-- <div class="content-box1">
      <el-steps :active="mydata.step" align-center>
        <el-step title="提交资质" description="提交店铺信息、公司资质等信息" />
        <el-step title="审核资质" description="预计审核时间1-7个工作日" />
        <el-step
          title="保证金汇款"
          description="部分店铺平台需要您支付一定的保证金。汇款到天利指定账户。"
        />
        <el-step
          title="签订协议"
          description="收到天利邮寄给您的协议后,签字盖章,然后回寄给天利。"
        />
        <el-step
          title="授权颁证"
          description="授权通过,提供可下载的电子授权证书。"
        />
      </el-steps>
    </div> -->

    <!-- 这里是每个步骤的内容 -->
    <step1 v-if="mydata.step === 1" :stepInfo="mydata.stepInfo"></step1>
    <step2 v-if="mydata.step === 2" :stepInfo="mydata.stepInfo"></step2>
    <step345
      v-if="mydata.step === 3 || mydata.step === 4 || mydata.step === 5"
      :stepInfo="mydata.stepInfo"
    ></step345>
  </div>
</template>

<script setup>
import step1 from "./components/step1/index.vue";
import step2 from "./components/step2/index.vue";
import step345 from "./components/step345/index.vue";
import { useRouter, useRoute } from "vue-router";

import { reactive, computed, ref, watch } from "vue";
// import { ElMessage } from 'element-plus'
import { ComponentSize, FormInstance, FormRules } from "element-plus";

import { Delete, Download, Plus, ZoomIn } from "@element-plus/icons-vue";

import { UploadFile, ElMessage } from "element-plus";

// 引入手机号验证码发送、销售授权申请、获取店铺平台列表、获取协议接口；
import {
  sendPhonCode,
  certificationSubmit,
  store_Platform,
  getAgreement,
} from "@/api/distributionAuthorization/authorizedOnlineShop/progressStep1/index.js";

//验证是否为手机号
import { isPhoneNumber } from "@/utils/validate.js";

const router = useRouter();
const route = useRoute();

const myForm = ref(null);

const mydata = reactive({
  step: "",
  stepInfo: {},
  xx: "/api/sale_auth/upload_file",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  btnText: "获取验证码",
  btnDisabled: false,
  protocolchecked: false, //是否已读

  dialogVisible: false,
  dialog: false,
  size: "default",
  upload: {
    dialogImageUrl: "",
    dialogVisible: "",
    disabled: false,
  },
  form: {
    // platform: "",
    shop_platform: "", //店铺平台id
    // name: "",
    shop_name: "", //店铺名称
    // link: "",
    shop_url: "", //店铺链接

    province: "", //店铺省份

    contact: "", //联系人
    qq: "", //qq号码
    phone: "", //电话号码

    phone_code: "", //手机验证码

    company_name: "", //公司名称

    company_number: "", //组织结构代码

    address: "", //公司地址

    intro: "", //公司简介

    is_merge: 0, //是否三合一(否：0，是：1)

    agreement_name: false,

    publication_license: "", // 出版物许可证
    company_number_img: "", // 组织机构代码证
    tax_certificate: "", // 税务登记证书
    business_license: "", // 营业执照
    identity_card: "", // 法人身份证
  },

  rules: {
    shop_platform: [
      {
        required: true,
        message: "请填写店铺平台",
      },
    ],
    shop_name: [
      {
        required: true,
        message: "请填写店铺名称",
      },
    ],

    shop_url: [
      {
        required: true,
        message: "请填写店铺链接",
      },
    ],
    province: [
      {
        required: true,
        message: "请选择省份",
      },
    ],
    contact: [
      {
        required: true,
        message: "请天写联系人",
      },
    ],
    qq: [
      {
        required: true,
        message: "请填写qq号码",
      },
    ],
    phone: [
      {
        required: true,
        message: "请填写电话号码",
      },
      { min: 11, max: 11, message: "请输入11位电话号码", trigger: "blur" },
    ],

    phone_code: [
      {
        required: true,
        message: "请填写手机验证码",
        trigger: "change",
      },
    ],

    company_name: [
      {
        required: true,
        message: "请填写公司名称",
      },
    ],
    company_number: [
      {
        required: true,
        message: "请输入组织机构代码或18位统一社会信用代码",
      },
    ],
    address: [
      {
        required: true,
        message: "请准确填写通讯地址，以确保能收到快递",
      },
    ],
    intro: [
      {
        required: true,
        message: "公司简介至少输入50个字",
      },
    ],
    is_merge: [
      {
        required: true,
        message: "请选择是否三合一",
      },
    ],
    // 出版物许可证
    publication_license: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 组织机构代码证
    company_number_img: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 税务登记证书
    tax_certificate: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 营业执照
    business_license: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    // 法人身份证
    identity_card: [
      {
        required: true,
        message: "请上传文件",
      },
    ],
    file_arr: [
      {
        required: true,
        message: "请上传文件",
        validator: file_arr_fn,
      },
    ],
  },
  // 第一个
  hiddenUpload1: false,
  dialogVisible1: false,
  dialogImageUrl1: "",
  fileList1: [],
  fiveM1: 1024 * 1024 * 5, // 单位字节B
  // 第二个
  hiddenUpload2: false,
  dialogVisible2: false,
  dialogImageUrl2: "",
  fileList2: [],
  fiveM2: 1024 * 1024 * 5, // 单位字节B
  // 第三个
  hiddenUpload3: false,
  dialogVisible3: false,
  dialogImageUrl3: "",
  fileList3: [],
  fiveM3: 1024 * 1024 * 5, // 单位字节B
  // 第四个
  hiddenUpload4: false,
  dialogVisible4: false,
  dialogImageUrl4: "",
  fileList4: [],
  fiveM4: 1024 * 1024 * 5, // 单位字节B
  // 第五个
  hiddenUpload5: false,
  dialogVisible5: false,
  dialogImageUrl5: "",
  fileList5: [],
  fiveM5: 1024 * 1024 * 5, // 单位字节B

  checked1: false,

  btnLoading: false,

  storePlatformArr: [], //店铺平台列表

  getAgreementObj: {}, //获取协议
});

// 监听路由的查询字符串
watch(
  () => {
    return route.query;
  },
  (newval, oldval) => {
    // console.log("newval", newval);
    mydata.step = Number(newval.step);
    if (newval.data) {
      mydata.stepInfo = JSON.parse(newval.data);
    }
  },
  {
    immediate: true,
  }
);

function file_arr_fn(rule, value, callback) {
  // console.log(mydata.form.is_merge);
  // console.log(mydata.form);

  // 如果没有合并
  if (mydata.form.is_merge === 0) {
    if (
      mydata.form.publication_license &&
      mydata.form.company_number_img &&
      mydata.form.tax_certificate &&
      mydata.form.business_license &&
      mydata.form.identity_card
    ) {
      callback();
    } else {
      callback(new Error("请上传文件"));
    }
  } else {
    if (
      mydata.form.publication_license &&
      mydata.form.business_license &&
      mydata.form.identity_card
    ) {
      callback();
    } else {
      callback(new Error("请上传文件"));
    }
  }

  // business_license
}

///////////////////////////////////////////////////////
//店铺平台
function storePlatformlist() {
  //店铺平台列表
  store_Platform({}).then((res) => {
    // console.log(res, "1222");
    mydata.storePlatformArr = res.data;
  });
}

storePlatformlist();

////////////////////////////////////////////////////////

function isMergeChange() {
  mydata.fileList1 = [];
  mydata.fileList2 = [];
  mydata.fileList3 = [];
  mydata.fileList4 = [];
  mydata.fileList5 = [];
  mydata.hiddenUpload1 = false;
  mydata.hiddenUpload2 = false;
  mydata.hiddenUpload3 = false;
  mydata.hiddenUpload4 = false;
  mydata.hiddenUpload5 = false;
  mydata.form.publication_license = ""; // 出版物许可证
  mydata.form.company_number_img = ""; // 组织机构代码证
  mydata.form.tax_certificate = ""; // 税务登记证书
  mydata.form.business_license = ""; // 营业执照
  mydata.form.identity_card = ""; // 法人身份证
}

//获取验证码,按钮点击事件
function submit() {
  // 如果不是手机号，那么提醒弹窗并终止代码
  if (isPhoneNumber(mydata.form.phone) === false) {
    ElMessage({
      message: "手机号码格式错误",
      type: "warning",
    });
    return;
  }

  mydata.btnDisabled = true;
  let num = 60;
  let intervalId = setInterval(() => {
    num = num - 1;
    mydata.btnText = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    }
  }, 1000);

  // 调用sendPhonCode方法，发送请求
  sendPhonCode({
    phone: mydata.form.phone,
  }).then((res) => {
    // console.log(res.data, "手机号获取验证码");
    // 存储后端返回的用户信息
    // localStorage.setItem("userInfo", JSON.stringify(res.data));
    // // 提示弹窗
    ElMessage({
      message: res.msg,
      type: "success",
    });
    // // 跳转页面
    // router.push({
    //   path: "/login/retrievePasswordLogin",
    // });
  }).catch((err)=>{
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
  })
}
///////////////////////////////////////////////////////
//提交申请事件函数
function submitList() {
  // 如果没有勾选协议
  if (!mydata.form.agreement_name) {
    // 提示弹窗
    ElMessage({
      message: "请在勾选协议后进行注册或登录",
      type: "warning",
    });
    // 终止执行
    return;
  }
  // console.log(mydata.form);
  myForm.value.validate((valid, fields) => {
    if (valid) {
      // console.log("ok");
      // //销售授权申请发送请求
      certificationSubmit(mydata.form).then((res) => {
        // console.log(res.data, "提交");
        // 存储后端返回的用户信息
        // localStorage.setItem("userInfo", JSON.stringify(res.data));
        // 提示弹窗
        ElMessage({
          message: "提交成功",
          type: "success",
        });
        // 跳转页面
        router.push({
          path: "/layout/list/progressStep2",
        });
      });
    }
  });
}

////////////////////////////////////////////////////////////////
//获取协议
function agreementFn() {
  getAgreement({}).then((res) => {
    // console.log(res, "获取协议");
    mydata.getAgreementObj = res.data;
  });
}

agreementFn();

///////////////////////////////////////////////////////
//点击事件
// function reviewQualificationsStep2Button() {
//   router.push({
//     path: "/layout/list/reviewQualificationsStep2",
//   });
// }

// const submitForm = async (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   await formEl.validate((valid, fields) => {
//     if (valid) {
//       console.log('submit!')
//     } else {
//       console.log('error submit!', fields)
//     }
//   })
// }

// const resetForm = (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   formEl.resetFields()
// }

// const options = Array.from({ length: 10000 }).map((_, idx) => ({
//   value: `${idx + 1}`,
//   label: `${idx + 1}`,
// }))

// const handleRemove = (file) => {
//   console.log(file)
// }

// const handlePictureCardPreview = (file) => {
//   dialogImageUrl.value = file.url!
//   dialogVisible.value = true
// }

// const handleDownload = (file) => {
//   console.log(file)
// }

// 第一个/////////////////////////////////////////////////
// 文件改变事件
function uploadChange1(file, fileList) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (file.size > mydata.fiveM1) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 赋值
    mydata.fileList1 = [];
  } else {
    // 赋值
    mydata.fileList1 = fileList;
    // 赋值
    mydata.hiddenUpload1 = mydata.fileList1.length !== 0 ? true : false;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList1);
}

// 文件移除事件
function uploadRemove1(file, fileList) {
  // 赋值
  mydata.fileList1 = fileList;
  // 赋值
  mydata.hiddenUpload1 = mydata.fileList1.length !== 0 ? true : false;
  if (mydata.hiddenUpload1) {
    mydata.form.publication_license = null;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList1);
}

// 文件预览事件
function uploadPreview1(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible1 = true;
  // 赋值地址
  mydata.dialogImageUrl1 = file.url;
}

// 出版物许可证-文件上传成功
function successFile1(val) {
  mydata.form.publication_license = val.data.url;
  // console.log(mydata.form);
}
// 组织机构代码证-文件上传成功
function successFile2(val) {
  mydata.form.company_number_img = val.data.url;
  // console.log(mydata.form);
}
// 税务登记证书-文件上传成功
function successFile3(val) {
  mydata.form.tax_certificate = val.data.url;
  // console.log(mydata.form);
}
// 营业执照-文件上传成功
function successFile4(val) {
  mydata.form.business_license = val.data.url;
  // console.log(mydata.form);
}
// 法人身份证-文件上传成功
function successFile5(val) {
  mydata.form.identity_card = val.data.url;
  // console.log(mydata.form);
}

// 第二个/////////////////////////////////////////////////
// 文件改变事件
function uploadChange2(file, fileList) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (file.size > mydata.fiveM2) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 赋值
    mydata.fileList2 = [];
  } else {
    // 赋值
    mydata.fileList2 = fileList;
    // 赋值
    mydata.hiddenUpload2 = mydata.fileList2.length !== 0 ? true : false;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList2);
}

// 文件移除事件
function uploadRemove2(file, fileList) {
  // 赋值
  mydata.fileList2 = fileList;
  // 赋值
  mydata.hiddenUpload2 = mydata.fileList2.length !== 0 ? true : false;
  // 打印一下
  // console.log("我的数据", mydata.fileList2);
  if (mydata.hiddenUpload2) {
    mydata.form.company_number_img = null;
  }
}

// 文件预览事件
function uploadPreview2(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible2 = true;
  // 赋值地址
  mydata.dialogImageUrl2 = file.url;
}

// 第三个/////////////////////////////////////////////////
// 文件改变事件
function uploadChange3(file, fileList) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (file.size > mydata.fiveM3) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 赋值
    mydata.fileList3 = [];
  } else {
    // 赋值
    mydata.fileList3 = fileList;
    // 赋值
    mydata.hiddenUpload3 = mydata.fileList3.length !== 0 ? true : false;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList3);
}

// 文件移除事件
function uploadRemove3(file, fileList) {
  // 赋值
  mydata.fileList3 = fileList;
  // 赋值
  mydata.hiddenUpload3 = mydata.fileList3.length !== 0 ? true : false;
  // 打印一下
  // console.log("我的数据", mydata.fileList3);
  if (mydata.hiddenUpload3) {
    mydata.form.tax_certificate = null;
  }
}

// 文件预览事件
function uploadPreview3(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible3 = true;
  // 赋值地址
  mydata.dialogImageUrl3 = file.url;
}

// 第四个/////////////////////////////////////////////////
// 文件改变事件
function uploadChange4(file, fileList) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (file.size > mydata.fiveM4) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 赋值
    mydata.fileList4 = [];
  } else {
    // 赋值
    mydata.fileList4 = fileList;
    // 赋值
    mydata.hiddenUpload4 = mydata.fileList4.length !== 0 ? true : false;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList4);
}

// 文件移除事件
function uploadRemove4(file, fileList) {
  // 赋值
  mydata.fileList4 = fileList;
  // 赋值
  mydata.hiddenUpload4 = mydata.fileList4.length !== 0 ? true : false;
  // 打印一下
  // console.log("我的数据", mydata.fileList4);
  if (mydata.hiddenUpload2) {
    mydata.form.business_license = null;
  }
}

// 文件预览事件
function uploadPreview4(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible4 = true;
  // 赋值地址
  mydata.dialogImageUrl4 = file.url;
}

// 第五个/////////////////////////////////////////////////
// 文件改变事件
function uploadChange5(file, fileList) {
  // console.log(fileList);
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (file.size > mydata.fiveM5) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 获取到旧列表
    let oldFileList5 = JSON.parse(JSON.stringify(mydata.fileList5));
    // 清空
    mydata.fileList5 = [];
    // 赋值
    mydata.fileList5 = oldFileList5;
  } else {
    // 赋值
    mydata.fileList5 = fileList;
    // 赋值
    mydata.hiddenUpload5 = mydata.fileList5.length === 2 ? true : false;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList5);
}

// 文件移除事件
function uploadRemove5(file, fileList) {
  // 赋值
  mydata.fileList5 = fileList;
  // 赋值
  mydata.hiddenUpload5 = mydata.fileList5.length === 2 ? true : false;
  // 打印一下
  // console.log("我的数据", mydata.fileList5);
  if (mydata.hiddenUpload5) {
    mydata.form.identity_card = null;
  }
}

// 文件预览事件
function uploadPreview5(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible5 = true;
  // 赋值地址
  mydata.dialogImageUrl5 = file.url;
}
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden !important;
  // border: 1px solid red;
  // padding-bottom: 40px; //距离bottomBar的距离

 
  /////////提示1————整个提示框
  :deep(.el-alert.el-alert--warning.is-light) {
    width: 343px;
    height: 45px;
    margin: 0 auto;
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    border-radius: 8px;
    margin-top:16px;
    margin-bottom: 16px;
    // border:1px solid red;
    //图标
    .el-icon.el-alert__icon {
      color: #1890ff;
      // border:1px solid red;
    }

    ///字体
    .el-alert__title {
      color: #000000d9;
      font-size: 16px;
      font-weight: 400;
    }

    //// x号
    .el-icon.el-alert__close-btn {
      display: none;
      // color:red;
    }
  }
  // 提示框1——————的图标大小
  :deep(.my-alert-1 .el-icon.el-alert__icon) {
    width: 24px;
    font-size: 24px;
  }

  //////内容 1 ——————步骤条  ////////////////////////////////////
  .content-box1 {
    width: 1200px;
    // height: 720px;
    margin: 0 auto;
    padding: 30px;
    border-radius: 8px 8px 0px 0px;
    // border: 1px solid red;
    background-color: #ffffff;
    border-bottom: 1px solid #dcdee2;

    //统一设置————每个进度块
    :deep(.el-step.is-horizontal.is-center) {
      width: 218px;
      // border:1px solid blue;
    }

    //统一设置————圆圈样式
    :deep(.el-step__icon.is-text) {
      width: 40px;
      height: 40px;
      border: 1px solid #a8abb2;
      //圆圈内字体
      .el-step__icon-inner {
        font-size: 20px;
        font-weight: 500;
      }
    }

    //统一设置————全部的第一行字
    :deep(.el-step__title) {
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      margin-bottom: 8px;
    }

    //统一设置————全部下面的字
    :deep(.el-step__description) {
      // border:1px solid blue;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 18px;
      padding: 0px 30px;
    }

    //统一设置————横线
    :deep(.el-step__line) {
      // border:1px solid blue;
      width: 150px;
      margin-left: 38px;
      height: 1px;
      top: 20px;
      color: #d4d6d9;
    }

    /////【完成状态】————的样式////////////
    :deep(.el-step__head.is-finish) {
      //圆圈
      .el-step__icon.is-text {
        background-color: #009de0;
        border: none;
      }
      //圆圈内字体
      .el-step__icon-inner {
        color: #ffffff;
      }
    }
    /////完成状态————的第一行字的样式
    :deep(.el-step__title.is-finish) {
      color: #333333;
    }
    /////完成状态————的下面字的样式
    :deep(.el-step__description.is-finish) {
      color: #333333;
    }

    ////【进程状态】——————的样式/////////////
    :deep(.el-step__head.is-process) {
      //圆圈
      .el-step__icon.is-text {
        border-color: #a8abb2;
      }
      //圆圈内字体
      .el-step__icon-inner {
        color: #a8abb2;
      }
    }
    ////进程状态——————的第一行字的样式
    :deep(.el-step__title.is-process) {
      color: #bbbdbf;
    }
    ////进程状态————下面字的样式
    :deep(.el-step__description.is-process) {
      color: #bbbdbf;
    }

    ////【等待状态】——————的样式/////////////
    :deep(.el-step__head.is-wait) {
      //圆圈
      .el-step__icon.is-text {
        border-color: #a8abb2;
      }
      //圆圈内字体
      .el-step__icon-inner {
        color: #a8abb2;
      }
    }

    ////等待状态——————的第一行字的样式
    :deep(.el-step__title.is-wait) {
      color: #bbbdbf;
    }

    ////等待中————下面字的样式
    :deep(.el-step__description.is-wait) {
      color: #bbbdbf;
    }
  }

}
////////弹窗（协议）
:deep(.el-dialog.agreement-box) {
  min-height: 343px;
}
// // 提示框2——————的图标大小
// :deep(.my-alert-2 .el-icon.el-alert__icon) {
//   width: 24px;
//   font-size: 24px;
// }
</style>
